import React, { useState } from "react";

import { Button } from "./ui/button";
import { Loader2 } from "lucide-react";

export default function InvestTermsAndConditions({ onComplete, loading }) {
  const terms = [
    "I understand that investments carry risk, and returns are not guaranteed.",
    "I confirm that the information provided is accurate and up to date.",
    "I accept the platform's terms of service and privacy policy.",
  ];

  const [checked, setChecked] = useState(new Array(terms.length).fill(false));
  const [holdStep, setHoldStep] = useState(true);
  const handleCheckboxChange = (index) => {
    const updated = [...checked];
    updated[index] = !updated[index];
    setChecked(updated);

    const allChecked = updated.every((val) => val === true);
    setHoldStep(!allChecked);
  };
  const handleSubmit = () => {
    onComplete?.(checked);
  };

  return (
    <div className="max-w-xl mx-auto p-6">
      <h2 className="text-3xl font-bold text-brand-primary mb-2">
        Let's wrap up
      </h2>
      <p className="text-gray-600 mb-6">
        We're almost there. Before you submit, please take a moment to review
        and acknowledge the terms and conditions outlined below.
      </p>

      <div className="space-y-6">
        {terms.map((term, index) => (
          <div key={index} className="flex items-start space-x-4">
            <div className="p-1">
              <input
                type="checkbox"
                checked={checked[index]}
                onChange={() => handleCheckboxChange(index)}
                className="w-6 h-6 mt-1 accent-red-600 border-red-500 rounded"
              />
            </div>
            <span className="text-gray-800 text-base">{term}</span>
          </div>
        ))}
      </div>
      <Button
        type="primary"
        disabled={holdStep}
        onClick={handleSubmit}
        className="px-32 py-3 mt-5 bg-gradient-to-tr from-purple-500 to-rose-500 text-white py-3 rounded-full text-sm font-medium"
      >
        {loading && <Loader2 className="animate-spin h-4 w-4 text-white" />}{" "}
        Submit Application
      </Button>
    </div>
  );
}
